export default "images/stanley3.jpg";